import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "locale"
    }}>{`Locale`}</h1>
    <p>{`The locale.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DANISH_LOCALE`}</strong>{` = 1279476846`}</p>
      <p parentName="blockquote">{`Danish.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ENGLISH_LOCALE`}</strong>{` = 1279477102`}</p>
      <p parentName="blockquote">{`English.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INTERNATIONAL_ENGLISH_LOCALE`}</strong>{` = 1279477097`}</p>
      <p parentName="blockquote">{`International English.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FINNISH_LOCALE`}</strong>{` = 1279477358`}</p>
      <p parentName="blockquote">{`Finnish.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FRENCH_LOCALE`}</strong>{` = 1279477362`}</p>
      <p parentName="blockquote">{`French.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GERMAN_LOCALE`}</strong>{` = 1279477613`}</p>
      <p parentName="blockquote">{`German.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ITALIAN_LOCALE`}</strong>{` = 1279478132`}</p>
      <p parentName="blockquote">{`Italian.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PORTUGUESE_LOCALE`}</strong>{` = 1279479911`}</p>
      <p parentName="blockquote">{`Portuguese.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SPANISH_LOCALE`}</strong>{` = 1279480688`}</p>
      <p parentName="blockquote">{`Spanish.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SWEDISH_LOCALE`}</strong>{` = 1279480695`}</p>
      <p parentName="blockquote">{`Swedish.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`JAPANESE_LOCALE`}</strong>{` = 1279478384`}</p>
      <p parentName="blockquote">{`Japanese.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARABIC_LOCALE`}</strong>{` = 1279476082`}</p>
      <p parentName="blockquote">{`Arabic`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CZECH_LOCALE`}</strong>{` = 1279476602`}</p>
      <p parentName="blockquote">{`Czech`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GREEK_LOCALE`}</strong>{` = 1279477618`}</p>
      <p parentName="blockquote">{`Greek`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HEBREW_LOCALE`}</strong>{` = 1279477858`}</p>
      <p parentName="blockquote">{`Hebrew`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HUNGARIAN_LOCALE`}</strong>{` = 1279477877`}</p>
      <p parentName="blockquote">{`Hungarian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`POLISH_LOCALE`}</strong>{` = 1279479916`}</p>
      <p parentName="blockquote">{`Polish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ROMANIAN_LOCALE`}</strong>{` = 1279480431`}</p>
      <p parentName="blockquote">{`Romanian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RUSSIAN_LOCALE`}</strong>{` = 1279480437`}</p>
      <p parentName="blockquote">{`Russian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TURKISH_LOCALE`}</strong>{` = 1279480946`}</p>
      <p parentName="blockquote">{`Turkish`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UKRAINIAN_LOCALE`}</strong>{` = 1279481195`}</p>
      <p parentName="blockquote">{`Ukrainian`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KOREAN_LOCALE`}</strong>{` = 1279478639`}</p>
      <p parentName="blockquote">{`en_KoreanLocale`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SIMPLIFIED_CHINESE_LOCALE`}</strong>{` = 1279476590`}</p>
      <p parentName="blockquote">{`simplified chinese`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TRADITIONAL_CHINESE_LOCALE`}</strong>{` = 1279480951`}</p>
      <p parentName="blockquote">{`traditional chinese`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      